import React, {useEffect} from 'react';
import {
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  NumberField,
  ReferenceField,
  ShowProps,
  ImageField,
  useUnselectAll,
} from 'react-admin';
import {Box} from '@material-ui/core';

import Aside from './Aside';
import FullnameField from '../users/FullnameField';
import CommunityMembers from './CommunityMembers/CommunityMembers';
import {RESOURCES} from '../common/constants';
import {useClearSelectedAdmin} from '../hooks';
import {useParams} from 'react-router-dom';
import CommunityTitle from './CommunityTitle';

const CommunityShow: React.FC<ShowProps> = props => {
  const unselectAll = useUnselectAll();
  const clearSelectedAdmin = useClearSelectedAdmin();
  const {id: communityId} = useParams() as {id: string};

  useEffect(() => {
    unselectAll(RESOURCES.COMMUNITY_JOINABLE_USERS);
    unselectAll(RESOURCES.COMMUNITY_MEMBERS);
    clearSelectedAdmin('community');
  }, [communityId]);

  return (
    <Show {...props} title={<CommunityTitle />} aside={<Aside />}>
      <TabbedShowLayout>
        <Tab label="Detail">
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="description" />
          <ReferenceField source="owner_id" reference={RESOURCES.USERS}>
            <FullnameField clickable={false} />
          </ReferenceField>
          <ImageField source="background_img_url" label="Background image" />
          <TextField source="privacy" />
          <NumberField source="user_count" />
        </Tab>
        <Tab label="Members" path="members">
          <Box marginBottom="1em">
            <CommunityMembers />
          </Box>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default CommunityShow;
